import request from '@/utils/request'

let WarehouseApi = {
  /*获取基础设置*/
  getData(data, errorback) {
    return request._post('/shop/warehouse.Setting/index', data, errorback);
  },
  /*保存基础设置*/
  saveData(data, errorback) {
    return request._post('/shop/warehouse.Setting/edit', data, errorback);
  },
  /*获取云仓明细*/
  getList(data, errorback) {
    return request._post('/shop/warehouse.Log/index', data, errorback);
  },
  /*获取当前可用云仓用户列表*/
  getWarehouseList(data, errorback) {
    return request._post('/shop/warehouse.warehouse/index', data, errorback);
  },
  /*获取用户云仓列表*/
  getWarehouseDetail(data, errorback) {
    return request._post('/shop/warehouse.warehouse/detail', data, errorback);
  },
  /*修改云仓库存*/
  edit(data, errorback) {
    return request._post('/shop/warehouse.warehouse/edit', data, errorback);
  },
}
export default WarehouseApi;



// WEBPACK FOOTER //
// ./src/api/warehouse.js